var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"defaultBox"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.nickname))]),_vm._v(" "),_c('div',{staticClass:"profilePhoto"},[_c('img',{attrs:{"src":_vm.profilePhoto,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"subTitle"},[_vm._v("开始答题时间")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(new Date(_vm.addTime).toLocaleString()))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"subTitle"},[_vm._v("答题结束时间")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(new Date(_vm.endTime).toLocaleString()))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"subTitle"},[_vm._v("答题时长")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.useTimeText))])])]),_vm._v(" "),(_vm.questionnaireType == 1)?_c('div',{staticClass:"right"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,on:{"click":function($event){$event.stopPropagation();}}},[(item.type == _vm.QuestionType.SCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewSCQ',{attrs:{"params":{ data: item, index: index }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewMCQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.SBQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewSBQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MBQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewMBQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.DLQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewDLQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.NPS)?_c('div',{staticClass:"item"},[_c('QuestionPreviewNPS',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.VOTE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewVote',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.SORT)?_c('div',{staticClass:"item"},[_c('QuestionPreviewSort',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.REMARK)?_c('div',{staticClass:"item"},[_c('QuestionPreviewRemark',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.SCORE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewScore',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.QA)?_c('div',{staticClass:"item"},[_c('QuestionPreviewQA',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.WRQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewWRQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.SRQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewSRQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.IMAGE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewImage',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MaxDiff)?_c('div',{staticClass:"item",class:{ 'max-diff': item.type === _vm.QuestionType.MaxDiff }},[_c('QuestionPreviewMaxDiff',{attrs:{"params":{
              data: _vm.defaultDataSubject[index],
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.UploadFile)?_c('div',{staticClass:"item"},[_c('QuestionPreviewUploadFile',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.DownloadFile)?_c('div',{staticClass:"item"},[_c('QuestionPreviewDownloadFile',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.CASCADER)?_c('div',{staticClass:"item"},[_c('QuestionPreviewCASCADER',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MatrixSCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewMatrixScq',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MatrixMCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewMatrixMcq',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ImageSCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewImageScq',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ImageMCQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewImageMcq',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ImageOrVideo)?_c('div',{staticClass:"item"},[_c('QuestionPreviewImageOrVideo',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Signature)?_c('div',{staticClass:"item"},[_c('QuestionPreviewSignature',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.NAME)?_c('div',{staticClass:"item"},[_c('QuestionPreviewName',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.GENDER)?_c('div',{staticClass:"item"},[_c('QuestionPreviewGender',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.AGE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewAge',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TEL)?_c('div',{staticClass:"item"},[_c('QuestionPreviewTel',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EMAIL)?_c('div',{staticClass:"item"},[_c('QuestionPreviewEmail',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.DATE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewDate',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TIME)?_c('div',{staticClass:"item"},[_c('QuestionPreviewTime',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ADDR)?_c('div',{staticClass:"item"},[_c('QuestionPreviewAddress',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.BDQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewBDQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.IDQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewIDQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ELQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewELQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.WX)?_c('div',{staticClass:"item"},[_c('QuestionPreviewWX',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Customize)?_c('div',{staticClass:"item"},[_c('QuestionPreviewCustomize',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.questionnaireType == 2)?_c('div',{staticClass:"right"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,on:{"click":function($event){$event.stopPropagation();}}},[(item.type == _vm.QuestionType.SCQ)?_c('div',{staticClass:"item"},[_c('ExamPreviewSCQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MCQ)?_c('div',{staticClass:"item"},[_c('ExamPreviewMCQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TFQ)?_c('div',{staticClass:"item"},[_c('ExamPreviewTFQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.SBQ)?_c('div',{staticClass:"item"},[_c('ExamPreviewSBQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.MBQ)?_c('div',{staticClass:"item"},[_c('ExamPreviewMBQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.QA)?_c('div',{staticClass:"item"},[_c('ExamPreviewQA',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.IMAGE)?_c('div',{staticClass:"item"},[_c('ExamPreviewIMAGE',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ClozeTest)?_c('div',{staticClass:"item"},[_c('ExamPreviewClozeTest',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.REMARK)?_c('div',{staticClass:"item"},[_c('ExamPreviewRemark',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.NAME)?_c('div',{staticClass:"item"},[_c('QuestionPreviewName',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.GENDER)?_c('div',{staticClass:"item"},[_c('QuestionPreviewGender',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.AGE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewAge',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TEL)?_c('div',{staticClass:"item"},[_c('QuestionPreviewTel',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EMAIL)?_c('div',{staticClass:"item"},[_c('QuestionPreviewEmail',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.DATE)?_c('div',{staticClass:"item"},[_c('QuestionPreviewDate',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TIME)?_c('div',{staticClass:"item"},[_c('QuestionPreviewTime',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ADDR)?_c('div',{staticClass:"item"},[_c('QuestionPreviewAddress',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.BDQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewBDQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.IDQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewIDQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ELQ)?_c('div',{staticClass:"item"},[_c('QuestionPreviewELQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.WX)?_c('div',{staticClass:"item"},[_c('QuestionPreviewWX',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Customize)?_c('div',{staticClass:"item"},[_c('QuestionPreviewCustomize',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.questionnaireType == 3)?_c('div',{staticClass:"right"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,on:{"click":function($event){$event.stopPropagation();}}},[(item.type == _vm.QuestionType.EvaluationSCQ)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewSCQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EvaluationMCQ)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewMCQ',{attrs:{"params":{ data: item, index: index },"showAnswer":true}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EvaluationWRQ)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewWRQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EvaluationNPS)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewNPS',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EvaluationScore)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewScore',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.TextDescription)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewDesc',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.NAME)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewName',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.GENDER)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewGender',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.AGE)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewAge',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ELQ)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewELQ',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.DATE)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewDate',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ADDR)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewAddress',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.EvaluationMatrixSCQ)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewMatrixScq',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.ImageOrVideo)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewImageOrVideo',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Audio)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewAudio',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Industry)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewIndustry',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Occupation)?_c('div',{staticClass:"item"},[_c('EvaluationPreviewOccupation',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e(),_vm._v(" "),(item.type == _vm.QuestionType.Customize)?_c('div',{staticClass:"item"},[_c('QuestionPreviewCustomize',{attrs:{"params":{
              data: item,
              answer: _vm.defaultDataAnswer[index],
              index: index,
            }}})],1):_vm._e()])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d5f8b7d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DataStatisticsPage/DialogDetail/index.vue
// module id = UEs2
// module chunks = 3